import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import type { ReactionProp } from "@src/app/types/Reactions";
import { reactionCount } from "@src/app/utils/reactionCount";
import cx from "classnames";

import { useReactions } from "../ReactionsContext";
import styles from "./ReactionSummary.module.css";

type ReactionSummaryProps = {
  reactions?: ReactionProp[];
  variant?: "hero" | "card";
};

export default function ReactionSummary({
  reactions,
  variant = "hero",
}: ReactionSummaryProps) {
  const context = useReactions();
  const source = reactions ?? context?.reactions ?? [];
  const hasError = reactions ? false : context?.error;

  const totalReactions = source.reduce((sum, r) => sum + r.count, 0);

  if (hasError || totalReactions === 0) {
    return null;
  }

  const topReactions = [...source]
    .filter((reaction) => reaction.count > 0)
    .sort((a, b) => b.count - a.count)
    .slice(0, 2);

  if (topReactions.length === 0) return null;

  return (
    <div
      className={cx(styles.summary, variant === "card" && styles.card)}
      aria-label={`${totalReactions} reactions`}
    >
      <div className={styles.icons}>
        {topReactions.map((reaction) => (
          <span key={reaction.id} className={styles.icon}>
            <DotLottieReact
              src={`/reactions/${reaction.id}.json`}
              loop
              autoplay
              className={styles.lottie}
            />
          </span>
        ))}
      </div>
      <span className={styles.count}>{reactionCount(totalReactions)}</span>
    </div>
  );
}
